export default __webpack_public_path__ + "static/media/icon-loading_spinner.6f5fe5a6.svg";